import { makeEditorModal } from '../Modal';
import { TinyMCE, Editor } from 'tinymce';
import { displayErrors, generateRandomId, getData, getPoints, getTaskId, insertToEditor, pointsValid, setWindowNode, toJsonHtml } from '../core/Utils';
import { FeatureClass } from '../core/FeatureClass';
import { getModalInputId, insertData } from "../save/SaveUtils";
import { renderAddButton } from './Choice';
import { inputTransformation } from '../save/Interface';

declare let tinymce:TinyMCE;


export function addOrderingInput(editor:Editor){
    const config = {
        featureName: "ordering",
        editor: editor,
        id: "ordering",
        icon: "ordered-list-rtl",
        tooltip: 'Sortieraufgabe',
        menuItems: [{
            name: 'edit-or',
            icon: 'edit-block',
            text: 'Bearbeiten',
            action: (editor:Editor, command:string) => {
                const node = setWindowNode(editor);
                const data = getData(node);
                createOrderingModal(editor, command, data);
            }
        }],
        buttonAction: (command:string) => {
            const options = ['', '', '']
            createOrderingModal(editor, command, {options: options, points: '', id: 0});
        },
        commandAction: (data:OrderingData) => {
            insertOrdering(data, editor);
        }    
    }
    const feature = new FeatureClass(config);
    feature.addToEditor(editor);
}

export interface OrderingData {
    id: number,
    options: Array<string>;
    points: number;
    type: string;
}

interface OrderingOption {
    value: string;
    correctIndex: number;
}

const createOrderingModal = (editor:Editor, command:string, data:OrderingData): void => {
    
    const modalId = 'create-ordering'
    const content = '<p>Hier kannst du eine Sortieraufgabe erstellen. Bitte gebe hier die richtige Reihenfolge an, sie wird dann für Schüler/-innen randomisiert.</p>' +
    '<div class="ordering-modal minimal-flex-table mb-2">' + 
    renderOrdering(data) + 
    '</div>' + 
    renderAddButton('add-order-option')



    const settings = {
        leftInput: {
            placeholder: "Punkte",
            text: "Punkte",
            type: "text",
            value: data.points,
        },
        submitBtn: {
            text: 'Einfügen',
            class: 'add-ordering',
        },
        id: data.id,
      //  faq: 15,
    }
    const onclick = function(modal){
        const data = getDataFromModal(modal);
        if (data){
            return insertData(data, editor, command, modalId)
        }
    }
    const modal = makeEditorModal(modalId, 'Sortieraufgabe erstellen', content, settings, onclick, addListeners);

    makeOrderOptionsSortable();

}



function getDataFromModal(modal):OrderingData|boolean{
    const errors = [];

    const points = getPoints(modal);
    const id = getModalInputId(modal);

    let missingEntries = 0;
    const options = [];
    modal.find(".order-option").each((ind, obj) => {

        const option = $(obj).find("input").val()

        options.push(option);

        if (option == ''){ // no input given
            $(obj).find("input").addClass("is-invalid");
            missingEntries += 1;
        }
    })

    if (!pointsValid(points)){
        errors.push("Die Eingabe braucht eine gültige Punktzahl");
    }

    if (missingEntries > 0){
        errors.push("Bei " + missingEntries + " Feldern fehlt noch eine Antwort");
    }


    if (errors.length == 0){
        return {
            options: options,
            points: points,
            id: id,
            type: "or",
        }
    } else {
        displayErrors(errors);
        return false;
    }
}


// Listeners
function addListeners(modal:JQuery){
    modal.on("click", ".add-order-option", function(){
        addOrderOption();
        setTableHeight();
    })
    modal.on("click", ".remove-order-option", function(){
        removeOrderOption(this);
        const table = getTable();
        table.removeAttr('style');
        setTableHeight();
    })
}

function addOrderOption(){
    const html = renderOption('');
    $(".ordering-modal").append(html)
    makeOrderOptionsSortable();
}

function removeOrderOption(btn:HTMLElement){
    const check = $(".order-option").length > 2;
    if (check){
        $(btn).parents(".order-option").remove();
    } else {
        errorToast("Es muss mindestens zwei Elemente geben");
    }
}

function makeOrderOptionsSortable(){
    const list = $("#create-ordering").find(".ordering-modal");
    list.sortable({
        group: "list",
        animation: 200,
        containment: "#create-ordering .modal-body",
      //  handle: ".handle",
        create: function(evt, ui){
            const table = getTable();
            table.css('min-height', table.css('height'));
        },
        start: function(evt, ui){
            const table = getTable();
            const height = table.height();
        },
        stop: function(evt, ui){
            const table = getTable();
            table.css('style', 'auto');
        }
    });
}


function getTable(){
    return $("#create-ordering").find(".ordering-modal")
}
function setTableHeight(){
    const table = getTable();
    table.css('min-height', table.css('height'));
}


// RENDERING
function renderOrdering(data:OrderingData):string {
    let s = '';
    data.options.forEach((item) => {
        s += renderOption(item);
    })
    return s;
}

function renderOption(item=''){
    const s = '<div class="d-flex align-items-center m-f-t-item mb-1 order-option">' +
                '<span class="me-3"><i class="handle fa fa-arrows-alt"></i></span>' +
                '<input type="text" class="form-control w-100 me-3 check-field" value="' + item + '">' +
                '<button class="btn btn-light-danger remove-order-option text-danger" tabindex="-1">' +
                    '<i class="fa fa-trash-alt"></i>' +
                '</button>' +
            '</div>';
    return s;
}


function insertOrdering(data:OrderingData, editor:Editor){

    const html = transformOrderingForInsert(data);    
    insertToEditor(html, editor);

}

export function transformOrderingForInsert(data:OrderingData):string {

    const html = renderDataForEditor(data);
    return html;
}

// RENDER DATA FOR EDITOR
function renderDataForEditor(data:OrderingData):string {
    data.type = "or";
    const json = toJsonHtml(data);

    const s = '<div id="ordering" class="mceNonEditable d-inline-block input-item" data-id="' + data.id + '" data-json="' + json + '">' +
        renderOptionsForEditor(data.options) + 
        '</div>' 

    return s;
}

function renderOptionsForEditor(options:Array<string>):string {
    let s = ''
    options.forEach((option) => {
        s += renderOptionForEditor(option);
    })
    return s;
}

function renderOptionForEditor(option:string):string{
    const s = '<div class="d-flex align-items-center m-f-t-item mb-1 order-option p-2 bg-light" style="min-width: 120px;">' +
            '<span class="me-3"><i class="handle fa fa-arrows-alt"></i></span>' +
            option + 
        '</div>';
    return s;
}


export function transformOrdering(data:OrderingData, ind:number):inputTransformation{
    const [html, correct] = renderOptionsForDisplay(data, ind);
    return {
        solution: {
            type: "or",
            id: data.id,
            correct: correct, // Liste der Random Ids in der richtigen Reihenfolge
            points: data.points,
        },
        html: html
    }
}

// RENDERING FOR DISPLAY
function renderOptionsForDisplay(data:OrderingData, indexInTask:number):[string, Array<number>] {
    let s = '<div class="d-inline-block input" data-type="' + data.type + '" data-id="' + data.id + '" data-name="' + data.id + '_' + indexInTask + '">'
    
    const ids = [];
    const options = []; // Options
    data.options.forEach((option) => {
        const id = generateRandomId(ids);
        ids.push(Number(id));
        options.push(option);
       // s += renderOptionForDisplay(option, id);
    })

    const copiedIds = ids.slice();
    

    // Now Mix Order for Display
    for (let i = 0; i < data.options.length; i++){
        const randomElementIndex = Math.floor(Math.random() * options.length);
        // 
        // 
        // 
        
        s += renderOptionForDisplay(options[randomElementIndex], ids[randomElementIndex]);

        ids.splice(randomElementIndex, 1);
        options.splice(randomElementIndex, 1);
    }


    s+= '</div>'

    
    return [s, copiedIds];
}

function renderOptionForDisplay(option:string, id:number):string{
    const s = '<div data-id="' + id + '" class="d-flex align-items-center m-f-t-item mb-1 order-option p-2 bg-light" style="min-width: 120px;">' +
            '<span class="me-3"><i class="handle fa fa-arrows-alt"></i></span>' +
            option + 
        '</div>';
    return s;
}


// SORTING FUNCTIONALITY
export function addOrderingToOrderingInputs(){
    const inputs = $(".input[data-type='or']");
    if (inputs.length > 0){
        inputs.each((ind, obj) => {
            $(obj).sortable({
                group: "list",
                animation: 50,
                // containment: "parent",
                tolerance: "pointer",
                // revert: true,
                //  handle: ".handle",
                create: function(evt, ui){
                    $(obj).css('min-height', $(obj).css('height'));
                },
                remove: function(evt, ui){
                    $(ui.item).sortable("cancel"); // kp ob sinnvoll
                }
            })
        })
    }
}